import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {CurrentRouteService} from "../../currentRoute.service";
import {AccountIdService, AccountNameService, AgencyIdService} from "../../account.service";
import {ApiService} from "../../api_service/api.service";
import {AccountsService} from "../../accounts/accounts.service";
import {SnackBarService} from "../../snackBar.service";
import {IntegrationProviderService} from "../integration-provider.service";
import * as _ from "lodash";

import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import {ThemePalette} from '@angular/material/core';

import {Observable, interval, pipe, } from 'rxjs';
import { switchMap,takeWhile } from 'rxjs/operators';
import {GoogleadsPostInterfaceData} from "../integrations-googleads/integrations-googleads.component";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ModelValidators} from "../../validators/validators";


export interface ShopifyPostInterfaceData {
  serviceName?: string,
  shop_name: string,
  webhook_id?: string,
  account_id?: string

}

@Component({
  selector: 'app-integrations-shopify',
  templateUrl: './integrations-shopify.component.html',
  styleUrls: ['./integrations-shopify.component.css']
})
export class IntegrationsShopifyComponent implements OnInit {

  helps = [
    "If the Reauthorize button is visible and connected is false then Reauthorize"
  ]


  myForm: UntypedFormGroup;
  agency_id: string;
  account_id: string;
  data = {};
  is_refresh_token: boolean = false;
  checked = false;
  color: ThemePalette = 'primary';
  is_loading = false;
  is_redirect_url = false;
  safeUrl: SafeResourceUrl;
  url: string;
  webhook_id: string;
  is_edit = false;
  shop_name:string;



  constructor(public router: Router,
              public route: ActivatedRoute,
              public dialog: MatDialog,
              private fb: UntypedFormBuilder,
              private currentrouteService: CurrentRouteService,
              private agencyidService: AgencyIdService,
              private accountidService: AccountIdService,
              private accountnameService: AccountNameService,
              private _integrationProviderService: IntegrationProviderService,
              private sanitizer: DomSanitizer
  ) {
  }// end constructor

  ngOnInit(): void {

    console.log('ARE WE WORKINHG?????????????')

    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);

    this.currentrouteService.announceCurrentRoute(this.router.url);

    this.route.params.subscribe(parms => {
      this.agency_id = parms['agency_id'],
        this.account_id = parms['account_id'],
        this.agencyidService.announceAgencyId(this.agency_id);
      this.accountidService.announceAccountId(this.account_id);
      this.load_data();
      //this.pollUntillCompleted();
    });

    let shop_name = '';
    this.myForm = this.fb.group({
      shop_name: [shop_name, Validators.required],
    })//end myForm

  } // end of ngOnInit

  load_data(){

    this.is_loading = true
    let endpoint = `webhooks/account/${this.account_id}`;

    let fu = this._integrationProviderService.get(endpoint).subscribe(x => {
      if (_.isEmpty(x['body'])) {
        //this.is_data = true
      } else {

        for (const [cn, v] of Object.entries(x['body'])) {
          console.log(cn, v);
          if (v['serviceName'] == 'shopify') {
            this.myForm.controls["shop_name"].setValue(v['shop_name']);
            console.log(v['redirect_url'])
            this.data = v;
            this.is_edit = true;
            this.webhook_id = v['webhook_id']
            this.shop_name = v['shop_name'];
            console.log(this.webhook_id)
          }
          //this.global_object[cn] = v
          //this.adwords_accounts.push(cn);
          //this.adwords_accounts_object[cn] = v;
        }
        //this.campaign_name_list = this.global_object['campaign_name_list']
      }

      if ('redirect_url' in this.data) {
        this.is_redirect_url = true;
      }

      if ('access_token' in this.data) {
        this.is_refresh_token = true;
        this.checked = true;
      }
      if ('redirect_url' in this.data) {
        this.url = this.data['redirect_url']
      }

      this.is_loading = false;


    }, error => {
      console.log('ERROR ', error)
      this.is_loading = false;
    }); //end apiService

  } // end load_data

  goBack() {
    window.history.back();
  } // end of goBack

  getRedirect(){

    let endpoint = `webhooks/account/${this.account_id}`;
    let fu = this._integrationProviderService.get(endpoint).subscribe(xx => {
      console.log('WOW!!!!!!! ong',fu)
      for (const [cn, v] of Object.entries(xx['body'])) {
        if (v['serviceName'] == 'shopify') {
          this.url = v['redirect_url'];
          this.data = v;
          window.open(this.url, 'popup', 'width=600,height=600');
        }
      }
    }) //end fu

  } //end getRedirect

  // reauthorize
  onPop() {

    if (this.myForm.controls["shop_name"].dirty===true){
      let fdata = this.myForm.value;
      let shop_name = fdata['shop_name'];

      let data: ShopifyPostInterfaceData = {webhook_id: this.webhook_id, shop_name: shop_name, account_id: this.account_id}
      let endpoint = `webhooks/${this.webhook_id}`
      let f = this._integrationProviderService.patch_shopify(endpoint, data).subscribe(x => {

      }); //end patch

    } else {
      console.log('no update')
      window.open(this.url, 'popup', 'width=600,height=600');
    }

  } //end onPop

  onDelete(){

    let endpoint = `webhooks/${this.webhook_id}`;
    let fu = this._integrationProviderService.delete(endpoint).subscribe(x => {
        console.log(x);
        this.load_data();
    }, error => {
      console.log('ERROR ', error)
      this.is_loading = false;
    }); //end _integrationProviderService.delete

  } //end onDelete

  onSubmit() {

    let fdata = this.myForm.value;
    let shop_name = fdata['shop_name'];

    console.log('shop_name',  shop_name)


    let endpoint = `webhooks/account/${this.account_id}`
    console.log(endpoint)
    let data: ShopifyPostInterfaceData = {serviceName: 'shopify', shop_name: shop_name}
    this._integrationProviderService.post_shopify(endpoint, data).subscribe(x => {
      console.log(x)
      this.url = x['body']['redirect_url']
      this.webhook_id = x['body']['webhook_id']
      console.log('WOW MAN',this.url)
      this.getRedirect()
      //this.onPop()
      this.load_data()
    }); //end post

  } // end of submit

} //end component

